module.exports = __webpack_public_path__ + "192a5b524dfe4a08258efa551636b881.png";